import React from "react";
import { cn } from "../lib/utils";

const toneClasses = {
  none: "",
  navy: "[filter:brightness(0)_saturate(100%)_invert(16%)_sepia(52%)_saturate(1502%)_hue-rotate(197deg)_brightness(92%)_contrast(96%)]",
  muted: "[filter:brightness(0)_saturate(100%)_invert(44%)_sepia(8%)_saturate(1141%)_hue-rotate(182deg)_brightness(95%)_contrast(88%)]",
  white: "[filter:brightness(0)_saturate(100%)_invert(100%)]",
  emerald: "[filter:brightness(0)_saturate(100%)_invert(35%)_sepia(58%)_saturate(735%)_hue-rotate(112deg)_brightness(96%)_contrast(94%)]",
  red: "[filter:brightness(0)_saturate(100%)_invert(27%)_sepia(91%)_saturate(2783%)_hue-rotate(344deg)_brightness(93%)_contrast(94%)]",
};

export default function AssetIcon({
  src,
  alt = "",
  className,
  imgClassName,
  tone = "none",
  hoverTone,
}) {
  return (
    <span className={cn("inline-flex items-center justify-center shrink-0", className)}>
      <img
        src={src}
        alt={alt}
        className={cn(
          "h-full w-full object-contain transition-[filter] duration-200",
          toneClasses[tone],
          hoverTone ? `group-hover:${toneClasses[hoverTone]}` : "",
          imgClassName,
        )}
      />
    </span>
  );
}
